import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import {
  AUTH_HEADER,
  SECURE_AUTH_TOKEN_KEY,
  SECURE_BASE_URL_KEY,
} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { DeleteUploadReadFileExpenseType } from "../../../domain/useages/expense-dashboard/delete-upload-read-file-expense";
import { RemoteDeleteUploadReadFileExpense } from "../../../data/usecases/expense-dashboard/remote-delete-upload-read-file-expense";

export interface DeleteUploadReadFileExpenseInterface {
  DeleteUploadReadFileExpenseState: FetchState;
  deleteUploadReadFileExpense: Function;
}

const initialStates = {
  DeleteUploadReadFileExpenseState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useDeleteUploadReadFileExpenseSlice: StateCreator<
  DeleteUploadReadFileExpenseInterface
> = (set, get) => ({
  ...initialStates,
  deleteUploadReadFileExpense: async (
    payload: DeleteUploadReadFileExpenseType.Params
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteDeleteUploadReadFileExpense =
      new RemoteDeleteUploadReadFileExpense(
        `${BASE_URL}${Endpoints.DELETE_UPLOAD_READ_FILE_EXPENSE}`,
        axiosHttpClient
      );

    let result = await remoteDeleteUploadReadFileExpense.update(payload);
    return result;
  },
});
